// Core-version comparison for the dashboard's "update available" indicator
// (core-update-mechanism). Strict X.Y.Z only — anything else compares as
// unknown (null), and unknown must never be rendered as outdated.

export function isCoreOutdated(boatVersion: string | null, latest: string | null): boolean {
  if (!boatVersion || !latest) return false;
  const re = /^(\d+)\.(\d+)\.(\d+)$/;
  const mb = re.exec(boatVersion);
  const ml = re.exec(latest);
  if (!mb || !ml) return false;
  for (let i = 1; i <= 3; i++) {
    const d = Number(mb[i]) - Number(ml[i]);
    if (d !== 0) return d < 0;
  }
  return false;
}
